import { render, staticRenderFns } from "./jcxList.vue?vue&type=template&id=bc8864b8&"
import script from "./jcxList.vue?vue&type=script&lang=js&"
export * from "./jcxList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports